export default function ChooseFigureKeyDownController(view, model) {
  return evt => {
    if (evt.repeat) return;
    if (model.done) {
      model.deferred.resolve();
      return;
    }
    console.log(evt);
    switch (evt.keyCode) {
      case 13:
        // RETURN
        view.submit();
        break;
      case 37:
      case 65:
        // Left
        view.selectPrevFigure();
        break;
      case 39:
      case 68:
        // Right
        view.selectNextFigure();
        break;
      case 27:
        // Esc
        view.cancel();
        break;
    }
  };
}